import React from "react"

import styled from "styled-components"

export const Highlighted = () => {
  return (
    <Anchor href={"https://www.covidchile.com"}>
      <Push>
        Casos confirmados de <u>COVID-19</u> 📈
      </Push>
    </Anchor>
  )
}

export default Highlighted

const Push = styled.div`
  background-color: #5ac8fa;
  padding-top: 1rem;
  padding-bottom: 1rem;
  :hover {
    background-color: #392396;
  }
  @media (max-width: 480px) {
    padding-top: 0.4rem;
    padding-bottom: 0.4rem;
    font-size: 0.8rem;
  }
`
const Anchor = styled.a`
  text-decoration: none !important;
  text-align: center;
  color: white;
  :hover {
    color: white;
  }
`
